import { render } from "./as-userWithRole.vue?vue&type=template&id=f2e07ae4&scoped=true&ts=true"
import script from "./as-userWithRole.vue?vue&type=script&lang=ts"
export * from "./as-userWithRole.vue?vue&type=script&lang=ts"

import "./as-userWithRole.vue?vue&type=style&index=0&id=f2e07ae4&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e07ae4"]])

export default __exports__